import styled from 'styled-components';

export const Ellipsis = styled.div.attrs({
  className: 'lds-ellipsis',
})`
`;
